import React, { useState, useEffect } from "react";
import Input from "shared/@forms/Input";
import styles from "./AddNewAppModal.module.css";

const MAX_APP_NAME_LENGTH = 50;

/**
 * View Component for Adding New Apps to Category Builder
 */
export function AddNewAppModal({ onClose, value, onChange, onSubmit }) {
  const [appName, setAppName] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    onChange(appName);
  }, [appName, onChange]);

  const handleClose = async (isSave) => {
    if (!isSave) {
      if (isSubmitting) return;
      setAppName("");
      onClose();
      return;
    }

    const trimmedAppName = appName.trim();
    if (!trimmedAppName) {
      setError("Please enter an App Name.");
      return;
    }
    if (trimmedAppName.length > MAX_APP_NAME_LENGTH) {
      setError(`App Name must be ${MAX_APP_NAME_LENGTH} characters or fewer.`);
      return;
    }

    setIsSubmitting(true);
    setError("");

    try {
      await onSubmit(trimmedAppName);
      setAppName("");
      onClose();
    } catch (submitError) {
      setError(submitError.message || "Unable to create this application.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.modalRow}>
          <span className={styles.modalTitle}>Add New App</span>
          <span className={styles.buttonSpan}>
            <button
              className={styles.cancelButton}
              disabled={isSubmitting}
              onClick={() => handleClose(false)}
            >
              <span>Cancel</span>
            </button>
            <button
              className={styles.saveButton}
              disabled={isSubmitting}
              onClick={() => handleClose(true)}
            >
              <span>{isSubmitting ? "Saving..." : "Save"}</span>
            </button>
          </span>
        </div>
        {error && (
          <div className={styles.error} role="alert">
            {error}
          </div>
        )}

        <div className={styles.modalRow}>
          <Input
            onChange={(e) => {
              setAppName(e.target.value);
              setError("");
            }}
            disabled={isSubmitting}
            placeholder={"App Name"}
            value={value}
          />
        </div>
      </div>
    </div>
  );
}
